
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Vector","d":"M1.886 7.949a.684.684 0 01-.653-.893l.645-2.07L.243 3.66A.69.69 0 01.041 2.9c.097-.27.36-.45.645-.45h2.062L3.476.494a.689.689 0 011.29 0l.727 1.957h2.063c.285 0 .547.18.645.45a.702.702 0 01-.203.765L6.371 4.994l.675 2.047a.68.68 0 01-.233.758.688.688 0 01-.795.03l-1.89-1.23-1.86 1.245a.691.691 0 01-.382.112V7.95z","fill":"#646E87"}})])
          )
        }
      }
    